import type {
	PortalTransactionDetailResponseDto,
	PortalTransactionListResponseDto,
	PortalTransactionQueryDto,
} from '@supply-mover-2-0/shared';
import {
	buildQueryString,
	portalFetch,
	portalFetchBlob,
} from '../lib/apiClient';

/**
 * Fetch the paginated transaction list across the user's assigned clients.
 */
export async function getTransactions(
	token: string,
	params: PortalTransactionQueryDto,
): Promise<PortalTransactionListResponseDto> {
	const qs = buildQueryString({
		page: params.page,
		limit: params.limit,
		clientId: params.clientId,
		dateFrom: params.dateFrom,
		dateTo: params.dateTo,
	});
	return portalFetch<PortalTransactionListResponseDto>(
		`/transactions${qs}`,
		token,
	);
}

/**
 * PD-15870 — one transaction with the documents its payment covered, already
 * scoped to the login (a child billed through a parent sees only its lines).
 */
export async function getTransactionDetail(
	token: string,
	transactionId: number,
): Promise<PortalTransactionDetailResponseDto> {
	return portalFetch<PortalTransactionDetailResponseDto>(
		`/transactions/${transactionId}`,
		token,
	);
}

/**
 * PD-15870 — the receipt PDF for a transaction, rendered on the fly from the
 * same scoped model the detail page shows.
 */
export async function downloadReceiptPdf(
	token: string,
	transactionId: number,
): Promise<Blob> {
	return portalFetchBlob(`/transactions/${transactionId}/receipt-pdf`, token);
}
